module.exports = __webpack_public_path__ + "assets/img/star_sentence9.2b5ade2f.png";